import pimg5 from "../images/clients/partners/Green-Bell-Packaging.png";
import pimg6 from "../images/clients/partners/LOGO-ADV-2048x996.png";
import pimg7 from "../images/clients/partners/ljmulogotransparent2.png";
import pimg8 from "../images/clients/partners/cropped-logo2888.png";
import pimg9 from "../images/clients/partners/salesforce-image-big.webp";
import pimg10 from "../images/clients/partners/meta-logo.png";
import pimg11 from "../images/clients/partners/google-cloud-logo.png";
import pimg12 from "../images/clients/partners/beaconhouse.png";
import pimg17 from "../images/clients/partners/client_logo_17.png";

import pimg13 from "../images/clients/client_logo_13.png";
import pimg14 from "../images/clients/client_logo_14.png";
import pimg15 from "../images/clients/client_logo_15.png";
import pimg16 from "../images/clients/client_logo_16.png";

const partners = [
  {
    pImg: pimg5,
  },
  {
    pImg: pimg6,
  },
  {
    pImg: pimg7,
  },
  {
    pImg: pimg8,
  },
  {
    pImg: pimg9,
  },
  {
    pImg: pimg10,
  },
  {
    pImg: pimg11,
  },
  {
    pImg: pimg12,
  },
  {
    pImg: pimg13,
  },
  {
    pImg: pimg14,
  },
  {
    pImg: pimg15,
  },
  {
    pImg: pimg16,
  },
  {
    pImg: pimg17,
  },
];

export default partners;
